export const UrlsServices = {
    beps: '/personas',
    requests: '/solicitudes',
    reports: '/reportes',
};

